export const getAgentTitle = (
  agentsMap: { [id: string]: string } | null,
  agentId: string | undefined,
  defaultTitle: string = 'Unknown Agent'
): string => {
  return agentId ? (agentsMap?.[agentId] ?? defaultTitle) : defaultTitle;
};
